<template>
  <div id="mypage-individualInfo-template" class="content-inner-fix" >
    <!-- BEGIN content-section -->
    <div class="content-section">
      <div class="table-wrap mt-0">
        <table class="table-body-only">
          <caption class="ir-text">개인정보수정</caption>
          <colgroup class="pc-cell">
            <col style="width: 160px" />
            <col />
          </colgroup>
          <colgroup class="mo-cell">
            <col style="width: 88px" />
            <col />
          </colgroup>
          <tbody>
          <tr>
            <th scope="row">이름</th>
            <td>{{member.name}}</td>
          </tr>
          <tr>
            <th scope="row">생년월일</th>
            <td>{{member.birthdate}}</td>
          </tr>
          <tr>
            <th scope="row">성별</th>
            <td>
              <div class="flex gap10">
                <label class="radio-inline label__radio" v-for="(key, value) in gender">
                  <input type="radio" name="inlineRadioOptions" v-model="member.gender" :value="value" :aria-label="'성별, ' + key">
                  <span class="custom-radio"></span>
                  {{key}}
                </label>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">아이디</th>
            <td>{{member.loginid}}</td>
          </tr>
          <tr>
            <th scope="row">비밀번호</th>
            <td>
              <a href="mypage-password.do" class="btn btn-gray btn-md">
                비밀번호 변경
              </a>
            </td>
          </tr>
          <tr>
            <th scope="row"><label for="hpFirst">휴대폰</label></th>
            <td>
              <div class="input-group phone-group">
                <div class="items1">
                  <div class="input-area wid120">
                    <select class="input__select" v-model="member.phone1" id="hpFirst" title="휴대폰 앞번호">
                      <option value="010">010</option>
                      <option value="011">011</option>
                      <option value="016">016</option>
                      <option value="017">017</option>
                      <option value="018">018</option>
                      <option value="019">019</option>
                    </select>
                  </div>
                  <div class="dash">-</div>
                </div>
                <div class="items2">
                  <div class="input-area wid120">
                    <input type="text" name="" v-model="member.phone2" class="input__text" placeholder="1234" title="휴대폰 중간번호">
                  </div>
                  <div class="dash">-</div>
                  <div class="input-area wid120">
                    <input type="text" name="" v-model="member.phone3" class="input__text" placeholder="1234" title="휴대폰 뒷번호">
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row"><label for="emailAccount">이메일</label></th>
            <td>
              <div class="input-group email-group">
                <div class="items1">
                  <div class="input-area wid200">
                    <label for="emailAccount" class="ir-text">이메일 계정</label>
                    <input type="text" id="emailAccount" name="" v-model="email1" placeholder="계정" title="이메일 계정">
                  </div>
                  <div class="dash">@</div>
                </div>
                <div class="items2">
                  <div class="input-area wid200">
                    <label for="emailSelectBox" class="ir-text">이메일 도메인 선택</label>
                    <select id="emailSelectBox" v-model="email2" v-on:change="emailChange" title="이메일 도메인 선택">
                      <option v-for="list in emailList" :value="list">{{list}}</option>
                      <option value="etc">직접입력</option>
                    </select>
                  </div>
                  <div class="input-area wid200">
                    <label for="emailSelectBoxDirect" class="ir-text">이메일 도메인 직접입력</label>
                    <input type="text" id="emailSelectBoxDirect" v-show="email2 === 'etc'" v-model="etcEmailAddress" placeholder="email.com" title="이메일 도메인 (직접입력)">
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row"><label for="postcode">주소</label></th>
            <td>
              <div class="address-wrap">
                <div class="input-group post-code">
                  <div class="input-area wid200">
                    <input type="text" placeholder="" id="postcode" v-model="member.zipcode" readonly title="우편번호">
                  </div>
                  <button type="button" class=" btn btn-primary btn-xsm" id="findPostCode" @click="findAddress" title="우편번호">
                    우편번호 검색
                  </button>
                </div>
                <div class="input-area">
                  <div id="searchPostCodeWrap" style="display:none;border:1px solid;width:500px;height:300px;margin:5px 0;position:relative; overflow: hidden;">
                    <img src="//t1.daumcdn.net/localimg/localimages/07/postcode/320/close.png" id="btnFoldWrap" style="cursor:pointer;position:absolute;right:0px;top:-1px;z-index:1" alt="접기 버튼" @click="foldDaumPostcode">
                  </div>
                </div>
              </div>
              <div class="address-wrap">
                <div class="input-group add-input">
                  <div class="input-area wid400">
                    <input type="text" v-model="member.addr1" disabled placeholder="" title="기본주소">
                  </div>
                  <div class="input-area wid400">
                    <input type="text" v-model="member.addr2" placeholder="" v-on:keyup="checked" title="상세주소">
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row"><label for="joinChannel">가입경로</label></th>
            <td>
              <div class="input-area mo-size wid400">
                <select title="가입경로 선택" id="joinChannel" v-model="channel"  v-on:change="channelChange">
                  <option value="지인소개">지인소개</option>
                  <option value="50+재단/캠퍼스/센터">50+재단/캠퍼스/센터</option>
                  <option value="서울시 유관홈페이지">서울시 유관홈페이지</option>
                  <option value="언론보도">언론보도(신문, 방송, 라디오 등)</option>
                  <option value="옥외광고">옥외광고(지하철, 버스, 현수막 등)</option>
                  <option value="타 기관 안내">타 기관 안내</option>
                  <option value="홍보책자">홍보책자(포스터, 전단지, 리플릿 등)</option>
                  <option value="인터넷/SNS 검색">인터넷/SNS 검색(페이스북 등)</option>
                  <option value="미디어광고">미디어광고(신문잡지, 라디오광고 등)</option>
                  <option value="etc">기타</option>
                </select>
                <input type="text" name="" v-model="channelEtc" id="joinChannelEtc" class="input__text margin-top-10" style="display:none;" v-on:keyup="checked" maxlength="30" placeholder="입력해주세요." title="가입경로 기타 내용">
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">
              <label for="joinMotive">가입동기 및<br>희망분야</label>
            </th>
            <td>
              <div class="input-area mo-size wid400">
                <select title="가입동기 및 희망분야 선택" v-model="motive" id="joinMotive" v-on:change="motiveChange">
                  <option value="인생후반전 준비에 대한 인식을 가지고자">인생후반전 준비에 대한 인식을 가지고자</option>
                  <option value="사회공헌 및 자원봉사에 관심이 있어서">사회공헌 및 자원봉사에 관심이 있어서</option>
                  <option value="NGO 등 인생후반전을 위한 단체를 구성하기 위해서">NGO 등 인생후반전을 위한 단체를 구성하기 위해서</option>
                  <option value="창업을 위해서">창업을 위해서</option>
                  <option value="재취업을 위해서">재취업을 위해서</option>
                  <option value="생각이나 취미가 같은 사람들을 만나기 위해">생각이나 취미가 같은 사람들을 만나기 위해</option>
                  <option value="etc">기타</option>
                </select>
                <input type="text" name="" v-model="motiveEtc" id="joinMotiveEtc" class="input__text margin-top-10" style="display:none;" v-on:keyup="checked" maxlength="30" placeholder="입력해주세요." title="가입동기 및 희망분야 기타 내용">
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row"><label for="myProfile">사진</label></th>
            <td>
              <div class="file-input-wrapper type2">
                <img v-if="member.photoUrl" :src="member.photoUrl" :alt="member.photoAlt || '프로필 사진'" class="file-uploads-thumb">
                <button type="button" class="btn-file-upload" @click="triggerFileInput">파일추가</button>
                <form name="profileform" id="profileform" method="post" enctype="multipart/form-data" action="/api/file-uploads">
                  <input type="file" ref="fileInput" name="file" class="real-file-input" style="width: 100%;opacity: 0;" id="myProfile" v-on:change="imgUrlChange('myProfile')" title="첨부파일">
                </form>
                <input type="text" class="display-file-name" placeholder="파일을 추가해 주세요." title="첨부파일"/>
                <button type="button" @click="deleteBt" style="position: relative; z-index: 10; background-color: #d32f2f;" class="deleteBtCss" aria-label="첨부된 사진파일 삭제" title="첨부된 사진파일 삭제">사진 삭제</button>
              </div>
              <div class="input-area" style="margin-top: 8px;">
                <label for="photoAltInput" class="ir-text">대체 텍스트</label>
                <input type="text" id="photoAltInput" v-model="member.photoAlt" class="input__text" maxlength="50" placeholder="사진에 대한 설명을 입력해 주세요." title="사진 대체 텍스트" style="max-width: 50%;">
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">나의<br class="mo-only"> 관심 50+</th>
            <td>
              <div class="interest-grid">
                <div class="check-wrap">
                  <input type="checkbox" class="sr-only" v-model="allCheck" name="inlineRadioOptions" @click="chkAllOrgs" id="like-orgs" aria-label="나의 관심 50+, 전체">
                  <label for="like-orgs"><span>전체</span></label>
                </div>
                <div class="check-wrap" v-for="org in orgList">
                  <input type="checkbox" class="sr-only" v-model="member.likeOrgs" name="inlineRadioOptions" :id="org.code" :value="org.code" :aria-label="'나의 관심 50+, ' + org.name">
                  <label :for="org.code"><span>{{org.name}}</span></label>
                </div>
              </div>
              <p class="interest-note mt-16">*관심 50+ 기관의 소식(문자, 뉴스레터)을 받을 수 있습니다.</p>
            </td>
          </tr>
          <tr>
            <th scope="row">주된 <br class="mo-only">직업군</th>
            <td>
              <div class="job-group-grid">
                <label class="radio-item" v-for="option in occuList" :key="option">
                  <input type="radio" class="sr-only" name="job_group" :id="'job_group_' + (occuList.indexOf(option) + 1)" :value="option" :checked="selectedOccupation === option" @click="onOccupationToggle(option)" :aria-label="'주된 직업군, ' + option">
                  <span class="custom-radio"></span>
                  {{ option }}
                  <input v-if="option === '기타'" type="text" size="12" maxlength="12" id="occuEtc" v-model="occuEtcVal" v-on:keyup="checked" title="주된 직업군 기타 입력란" class="input-other">
                </label>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">E-mail 수신</th>
            <td>
              <div class="flex gap10">
                <label class="radio-inline label__radio">
                  <input type="radio" name="emailCheckOptions" v-model="member.emailCheck" value="Y" aria-label="E-mail 수신 여부, 수신">
                  <span class="custom-radio"></span>
                  수신
                </label>
                <label class="radio-inline label__radio">
                  <input type="radio" name="emailCheckOptions" v-model="member.emailCheck" value="N" aria-label="E-mail 수신 여부, 비수신">
                  <span class="custom-radio"></span>
                  비수신
                </label>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">SMS수신</th>
            <td>
              <div class="flex gap10">
                <label class="radio-inline label__radio">
                  <input type="radio" name="smsCheckOptions" v-model="member.smsCheck" value="Y" aria-label="SMS 수신 여부, 수신">
                  <span class="custom-radio"></span>
                  수신
                </label>
                <label class="radio-inline label__radio">
                  <input type="radio" name="smsCheckOptions" v-model="member.smsCheck" value="N" aria-label="SMS 수신 여부, 비수신">
                  <span class="custom-radio"></span>
                  비수신
                </label>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">구직 의사</th>
            <td>
              <div class="job-seeking-status new">
                <div class="radio-item-desc">
                  <span class="">{{jobSearchStatusLabel}}</span>
                  <p class="description">일자리 몽땅에서 제공하는 일자리 추천 정보를 수신합니다.</p>
                </div>
                <button class="btn btn-xsm btn-gray" @click="showJobSearchStatusModal">구직의사 변경</button>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="button-area flex-justify-between mo-button-reverser mt-32">
        <div>
          <a href="#" class="btn btn-secondary btn-md" @click.prevent="slCan" title="연계 철회하기">연계 철회하기</a>
          <a href="#" class="btn btn-secondary btn-md" @click.prevent="showWithdrewModal" title="탈퇴하기">탈퇴하기</a>
        </div>
        <form id="myEduForm" name="myEduForm" method="post" action="/slMemberLinkReqCancel">
          <input type="hidden" name="instCd" id="instCd" value="B55366"/><!-- 평생학습포털 서울런4050 행정표준기관 코드 -->
        </form>
        <withdrew-modal :withdrewModal="withdrewModal" @withdrewModal-close="noShowWithdrewModal"></withdrew-modal>
        <job-search-status-modal :jobSearchStatusModal="jobSearchStatusModal" :jobSearchStatus="member.jobSearchStatus" @update:jobSearchStatus="noJobSearchStatusModal"></job-search-status-modal>
        <div>
          <a href="#" class="btn btn-primary btn-md" @click.prevent="updateInfo" title="수정하기">
            <i class="ico ico-pen-wt" aria-hidden="true"></i>
            수정하기
          </a>
        </div>
      </div>
    </div>
    <!-- END content-section -->
  </div>
</template>
<script>
/* global daum */
import Axios from 'axios';
import WithdrewModal from './WithdrewModal.vue';
import JobSearchStatusModal from './JobSearchStatusModal.vue';

const occuList = [
  '경영/금융/사무/보험',
  '공무원(교사)',
  '교육/강사/연구/법률',
  '의료/보건/사회복지',
  '마케팅/무역',
  '전문직(의사/변호사 등)',
  '문화/예술/신문방송/디자인',
  '영업/판매/고객상담/CS',
  '건설/건축/환경/산업',
  'IT/정보통신/웹',
  '숙박/음식/여행/스포츠/경비청소',
  '전업주부',
  '무직',
  '기타',
];

const gender = {
  M: '남성',
  F: '여성',
};

const emailCheck = {
  Y: '수신',
  N: '거부',
};

const smsCheck = {
  Y: '수신',
  N: '거부',
};

const jobSearchStatus = {
  SEEKING: '구직희망중',
  NOT_SEEKING: '구직의사없음',
};

const emailList = [
  'naver.com',
  'hanmail.net',
  'daum.net',
  'gmail.com',
  'google.com',
  'nate.com',
  'yahoo.com',
  'paran.com',
  'korea.com',
  'freechal.com',
];


const joinPurpose = [
  '인생후반전 준비에 대한 인식을 가지고자',
  '사회공헌 및 자원봉사에 관심이 있어서',
  'NGO 등 인생후반전을 위한 단체를 구성하기 위해서',
  '창업을 위해서',
  '재취업을 위해서',
  '생각이나 취미가 같은 사람들을 만나기 위해',
];
const applyPath = [
  '서울시 유관홈페이지',
  '언론보도',
  '홍보책자',
  '옥외광고',
  '미디어광고',
  '인터넷/SNS 검색',
  '타 기관 안내',
  '50+재단/캠퍼스/센터',
  '지인소개',
];

export default {
  name: 'mypage-myinfo-template',
  props: ['member', 'orgList', 'orgCode'],
  components: {
    WithdrewModal,
    JobSearchStatusModal,
  },
  data() {
    return {
      emailList,
      joinPurpose,
      applyPath,
      etcEmailAddress: '',
      allCheck: false,
      motive: '',
      channel: '',
      email1: '',
      withdrewModal: false,
      jobSearchStatusModal: false,
      email2: '',
      channelEtc: '',
      motiveEtc: '',
      gender,
      occuPation: [],
      occuPationStr: '',
      occuList,
      occuEtcVal: '',
      emailCheck,
      smsCheck,
      jobSearchStatus,
      jobSearchStatusLabel: '',
    };
  },
  computed: {
    selectedOccupation: {
      get() {
        return this.member.occuPation[0] || '';
      },
      set(value) {
        this.member.occuPation = value ? [value] : [];
        this.occuPation = value ? [value] : [];
        this.occuPationStr = value || '';
      }
    }
  },
  methods: {
    checked(event) {
      if (event.key === "'") {
        alert("'는 사용 하실 수 없습니다.");
        this.channelEtc = this.channelEtc.replace("'", '');
        this.motiveEtc = this.motiveEtc.replace("'", '');
        this.occuEtcVal = this.occuEtcVal.replace("'", '');
        this.member.addr2 = this.member.addr2.replace("'", '');
      }
    },
    onOccupationToggle(option) {
      if (this.selectedOccupation === option) {
        this.selectedOccupation = '';
      } else {
        this.selectedOccupation = option;
      }
    },
    updateInfo() {
      if (!this.email2 || !this.email1) {
        alert('이메일을 입력해 주세요.');
      } else if (!this.member.phone1 || !this.member.phone2 || !this.member.phone3) {
        alert('휴대폰를 입력해 주세요.');
      } else if (!this.member.zipcode || !this.member.addr1 || !this.member.addr2) {
        alert('주소를 입력해 주세요.');
      } else if (!this.channel || (this.channel === 'etc' && !this.channelEtc)) {
        alert('가입경로를 입력해 주세요.');
      } else if (!this.motive || (this.motive === 'etc' && !this.motiveEtc)) {
        alert('가입동기 및 희망분야를 입력해 주세요.');
      } else if (this.member.likeOrgs.length === 0) {
        alert('나의 관심 50+를 최소 한 개의 선택이 필요합니다.');
        $('#like-orgs').focus();
      } else {
        const email2 = this.email2 !== 'etc' ? this.email2 : this.etcEmailAddress;
        const channel = this.channel !== 'etc' ? this.channel : this.channelEtc;
        const motive = this.motive !== 'etc' ? this.motive : this.motiveEtc;
        const mail = `${this.email1}@${email2}`;
        const etc = this.occuPationStr.substring(0, 2);
        if (etc === '기타') {
          const front = '기타(';
          const end = ')';
          this.occuPationStr = front + document.getElementById('occuEtc').value + end;
          this.occuEtcVal = document.getElementById('occuEtc').value;
        }
        if (this.occuPationStr === '') {
          this.occuPationStr = this.member.occuPation.toString();
        }

        const Params = {
          email: mail,
          birthdate: this.member.birthdate,
          phone1: this.member.phone1,
          phone2: this.member.phone2,
          phone3: this.member.phone3,
          zipcode: this.member.zipcode,
          addr1: this.member.addr1,
          addr2: this.member.addr2,
          gender: this.member.gender,
          applyPath: channel,
          joinPurpose: motive,
          likeOrgs: this.member.likeOrgs,
          photoSignUrl: this.member.photoSignUrl,
          photoUrl: this.member.photoUrl,
          photoAlt: this.member.photoAlt,
          occuPation: this.occuPationStr,
          jobSearchStatus: this.member.jobSearchStatus,
          emailCheck: this.member.emailCheck,
          smsCheck: this.member.smsCheck,
        };
        console.log(Params);
        Axios.put('/api/members/info', Params).then(() => {
          alert('저장되었습니다.');
          location.reload();
        }).catch((e) => {
          alert(e.response.data.msg);
        });
      }
    },
    // imgSignUrlChange() {
    //   $('#signform').ajaxSubmit({
    //     dataType: 'json',
    //     error: (err) => {
    //       alert(err.msg);
    //     },
    //     success: (response, statusText, xhr) => {
    //       if (xhr.status === 401) {
    //         alert('로그아웃 상태입니다.');
    //         location.href = '/login.do';
    //       } else if (xhr.status < 400) {
    //         this.member.photoSignUrl = response.filename;
    //         if (response.filename === 'false') {
    //           alert('사진의 가로와 세로 길이를 확인해 주세요.');
    //           document.getElementById('mySign').value = '';
    //           this.member.photoSignUrl = '';
    //         } else {
    //           this.member.photoSignUrl = response.filename;
    //         }
    //       } else {
    //         alert(statusText);
    //       }
    //     },
    //   });
    // },
    imgUrlChange() {
      const that = this;
      $('#profileform').ajaxSubmit({
        dataType: 'json',
        error: (err) => {
          alert(err.msg);
        },
        success: (response, statusText, xhr) => {
          if (xhr.status === 401) {
            alert('로그아웃 상태입니다.');
            location.href = '/login.do';
          } else if (xhr.status < 400) {
            that.member.photoUrl = response.filename;
          } else {
            alert(statusText);
          }
        },
      });
    },
    motiveValue() {
      const purpose = this.joinPurpose.filter(item => item === this.member.joinPurpose);
      if (purpose && purpose.length > 0) {
        this.motive = this.member.joinPurpose;
      } else {
        this.motive = 'etc';
        this.motiveEtc = this.member.joinPurpose;
      }
    },
    channelValue() {
      const route = this.applyPath.filter(item => item === this.member.applyPath);
      if (route && route.length > 0) {
        this.channel = this.member.applyPath;
      } else {
        this.channel = 'etc';
        this.channelEtc = this.member.applyPath;
      }
    },
    emailValue() {
      this.email1 = this.member.email.split('@')[0];
      const emailAddress = this.member.email.split('@')[1];
      let isSame = false;
      emailList.forEach((item) => {
        if (item === emailAddress) {
          isSame = true;
        }
      });
      if (isSame) {
        this.email2 = emailAddress;
        this.etcEmailAddress = '';
      } else {
        this.email2 = 'etc';
        this.etcEmailAddress = emailAddress;
      }
    },
    motiveChange() {
      const element = document.getElementById('joinMotiveEtc');
      if (element) {
        if (this.motive === 'etc') {
          element.style.display = 'block';
        } else {
          element.style.display = 'none';
        }
      }
    },
    emailChange() {
      const element = document.getElementById('emailSelectBoxDirect');
      if (element) {
        if (this.email2 === 'etc') {
          element.style.display = 'block';
        } else {
          element.style.display = 'none';
        }
      }
    },
    channelChange() {
      const element = document.getElementById('joinChannelEtc');
      if (element) {
        if (this.channel === 'etc') {
          element.style.display = 'block';
        } else {
          element.style.display = 'none';
        }
      }
    },
    chkAllOrgs() {
      if (this.allCheck) {
        this.orgCode.forEach((item) => {
          this.member.likeOrgs.push(item);
        });
      } else {
        this.member.likeOrgs = [];
      }
    },
    foldDaumPostcode() {
      const elementWrap = document.getElementById('searchPostCodeWrap');
      // iframe을 넣은 element를 안보이게 한다.
      elementWrap.style.display = 'none';
    },
    findAddress() {
      const thisVal = this;
      const elementWrap = document.getElementById('searchPostCodeWrap');
      // 현재 scroll 위치를 저장해놓는다.
      const currentScroll = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
      daum.postcode.load(() => {
        new daum.Postcode({
          oncomplete(data) {
            // 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

            // 각 주소의 노출 규칙에 따라 주소를 조합한다.
            // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
            let fullAddr = data.address; // 최종 주소 변수
            let extraAddr = ''; // 조합형 주소 변수

            // 기본 주소가 도로명 타입일때 조합한다.
            if (data.addressType === 'R') {
              // 법정동명이 있을 경우 추가한다.
              if (data.bname !== '') {
                extraAddr += data.bname;
              }
              // 건물명이 있을 경우 추가한다.
              if (data.buildingName !== '') {
                extraAddr += (extraAddr !== '' ? `,${data.buildingName}` : data.buildingName);
              }
              // 조합형주소의 유무에 따라 양쪽에 괄호를 추가하여 최종 주소를 만든다.
              fullAddr += (extraAddr !== '' ? `(${extraAddr})` : '');
            }

            // 우편번호와 주소 정보를 해당 필드에 넣는다.
            // 5자리 새우편번호 사용
            // document.getElementById('postcode').value = data.zonecode;
            thisVal.member.addr1 = fullAddr;
            thisVal.member.zipcode = data.zonecode;

            // iframe을 넣은 element를 안보이게 한다.
            // (autoClose:false 기능을 이용한다면, 아래 코드를 제거해야 화면에서 사라지지 않는다.)
            elementWrap.style.display = 'none';

            // 우편번호 찾기 화면이 보이기 이전으로 scroll 위치를 되돌린다.
            document.body.scrollTop = currentScroll;
          },
          // 우편번호 찾기 화면 크기가 조정되었을때 실행할 코드를 작성하는 부분. iframe을 넣은 element의 높이값을 조정한다.
          onresize(size) {
            elementWrap.style.height = `${size.height}px`;
          },
          width: '100%',
          height: '100%',
        }).embed(elementWrap);
      });
      // iframe을 넣은 element를 보이게 한다.
      elementWrap.style.display = 'block';
    },
    showWithdrewModal() {
      $('body').addClass('modal-open');
      this.withdrewModal = true;
    },
    noShowWithdrewModal() {
      this.withdrewModal = false;
    },
    showJobSearchStatusModal() {
      $('body').addClass('modal-open');
      this.jobSearchStatusModal = true;
    },
    noJobSearchStatusModal(code) {
      this.member.jobSearchStatus = code;
      this.jobSearchStatusModal = false;
      this.getJobSearchStatusLabel();
    },
    occuPationEtc() {
      const str = this.member.occuPation.toString();
      const etc = str.substring(0, 2);
      if (etc === '기타') {
        const left = str.indexOf('(');
        const right = str.indexOf(')');
        const sub = str.substring(left, right);
        const len = sub.length;
        const subPlus = sub.substring(1, len);
        document.getElementById('occuEtc').value = subPlus;
        this.occuEtcVal = subPlus;
        this.member.occuPation = [etc];
        this.occuPationStr = etc;
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    slCan() {
      const result = window.confirm('서울시평생학습포털 회원정보와 연계를 철회하시겠습니까?');
      if (result) {
        $('#myEduForm').ajaxSubmit({
          dataType: 'json',
          error: (err) => {
            alert(err.msg);
          },
          success: (response, statusText) => {
            if (statusText === 'success') {
              alert('연계가 철회 되었습니다.');
            }
          },
        });
      }
    },
    getJobSearchStatusLabel() {
      this.jobSearchStatusLabel = jobSearchStatus[this.member.jobSearchStatus];
    },
    deleteBt() {
      const deleteBtn = document.querySelector('.deleteBtCss');
      const previewImg = document.querySelector('.file-uploads-thumb');
      const fileNameInput = document.querySelector('.display-file-name');

      if (previewImg) {
        previewImg.style.display = 'none'; // 1. 이미지 숨기기
        previewImg.src = ''; // 2. (선택 사항) 이미지 소스 제거
      }
      // 3. (선택 사항) 파일 이름 입력창 초기화
      if (fileNameInput) fileNameInput.value = '';
      // 4. (선택 사항) 실제 input[type="file"] 초기화
      const fileInput = document.querySelector('#myProfile');
      if (fileInput) fileInput.value = '';

      const Params = {
          photoUrl: '',
        };
        Axios.put('/api/members/potoDel', Params).then(() => {
          alert('파일이 삭제되었습니다.');
        }).catch((e) => {
          alert(e.response.data.msg);
        });
    },
  },
  mounted() {
    this.emailValue();
    this.motiveValue();
    this.channelValue();
    this.motiveChange();
    this.channelChange();
    this.emailChange();
    this.occuPationEtc();
    this.getJobSearchStatusLabel();
  },
};
</script>

<style scoped>
/** 주소: 우편번호(readonly)·기본주소(disabled) 시 색상 외 패턴(점선)·아이콘(잠금)으로 구분 */
.address-wrap input[readonly],
.address-wrap input:disabled {
    color: #222 !important;
    -webkit-text-fill-color: #222;
    opacity: 1;
    /* 색상만이 아닌 외곽선 패턴(점선)으로 '직접 입력 불가' 구분 */
    border: 1px dashed #767676;
    background-color: #f2f2f2;
    /* 주변정보: 잠금 아이콘으로 비활성 입력란임을 인지 */
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23767676' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3' y='11' width='18' height='11' rx='2'/%3E%3Cpath d='M7 11V7a5 5 0 0 1 10 0v4'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 8px center;
    padding-right: 30px;
}

/* 체크박스(관심 50+): 선택 시 굵은 외곽선 + 굵은 흰색 체크(✓) + 라벨 굵게 = 색상 외 다중 형태 단서
   기존 전역 CSS는 선택/미선택이 배경색으로만 구분됨 */
.check-wrap input[type="checkbox"]:checked + label:before {
    border: 2px solid var(--color-secondary);
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='20 6 9 17 4 12'/%3E%3C/svg%3E");
    background-size: 14px 14px;
}
/* 선택 시 라벨 텍스트 굵게(주변정보 단서) */
.check-wrap input[type="checkbox"]:checked + label > span {
    font-weight: 700;
}

/* 사진 삭제 버튼: reset.css의 button{outline:0}으로 포커스링이 사라져 키보드 포커스가 안 보임
   → 다른 버튼(.btn-file-upload)과 동일하게 포커스 아웃라인 복원 */
.deleteBtCss:focus,
.deleteBtCss:focus-visible {
    outline: 2px solid #005fcc;
    outline-offset: 2px;
}
</style>



// WEBPACK FOOTER //
// IndividualInfo.vue?1ea56cfe